import v4 from 'uuid/v4'
import moment from 'moment'

const today = moment()
const birthPT = moment().year(today.get('year') - 1)
const birthDE = moment().year(today.get('year') - 5)

const staticBirthPT = birthPT.toString()
const staticBirthDE = birthDE.toString()

const portuguesRecommendations1Year = [
  {
    id: v4(),
    date: today.toString(),
    vaccineCode: '1',
    pathologyId: '9861002',
    doseNumber: 3,
    status: 'DUE',
    dateCriterion: {
      recommended: moment(new Date(staticBirthPT)).add(1, 'year').add(2, 'days').toString(),
      earliest: moment(new Date(staticBirthPT)).add(11, 'months').toString(),
      latest: moment(new Date(staticBirthPT)).add(1, 'year').add(1, 'months').toString()
    }
  },
  {
    id: v4(),
    date: today.toString(),
    vaccineCode: '1',
    pathologyId: '23511006',
    doseNumber: 1,
    status: 'DUE',
    dateCriterion: {
      recommended: moment(new Date(staticBirthPT)).add(1, 'year').add(2, 'days').toString(),
      earliest: moment(new Date(staticBirthPT)).add(11, 'months').toString(),
      latest: moment(new Date(staticBirthPT)).add(1, 'year').add(1, 'months').toString()
    }
  },
  {
    id: v4(),
    date: today.toString(),
    vaccineCode: '1',
    pathologyId: '14189004',
    doseNumber: 1,
    status: 'DUE',
    dateCriterion: {
      recommended: moment(new Date(staticBirthPT)).add(1, 'year').add(2, 'days').toString(),
      earliest: moment(new Date(staticBirthPT)).add(11, 'months').toString(),
      latest: moment(new Date(staticBirthPT)).add(1, 'year').add(1, 'months').toString()
    }
  },
  {
    id: v4(),
    date: today.toString(),
    vaccineCode: '1',
    pathologyId: '240526004',
    doseNumber: 1,
    status: 'DUE',
    dateCriterion: {
      recommended: moment(new Date(staticBirthPT)).add(1, 'year').add(2, 'days').toString(),
      earliest: moment(new Date(staticBirthPT)).add(11, 'months').toString(),
      latest: moment(new Date(staticBirthPT)).add(1, 'year').add(1, 'months').toString()
    }
  },
  {
    id: v4(),
    date: today.toString(),
    vaccineCode: '1',
    pathologyId: '36653000',
    doseNumber: 1,
    status: 'DUE',
    dateCriterion: {
      recommended: moment(new Date(staticBirthPT)).add(1, 'year').add(2, 'days').toString(),
      earliest: moment(new Date(staticBirthPT)).add(11, 'months').toString(),
      latest: moment(new Date(staticBirthPT)).add(1, 'year').add(1, 'months').toString()
    }
  },
  {
    id: v4(),
    date: today.toString(),
    vaccineCode: '1',
    pathologyId: '709410003',
    doseNumber: 4,
    status: 'DUE',
    dateCriterion: {
      recommended: moment(new Date(staticBirthPT)).add(18, 'months').add(2, 'days').toString(),
      earliest: moment(new Date(staticBirthPT)).add(17, 'months').toString(),
      latest: moment(new Date(staticBirthPT)).add(19, 'months').toString()
    }
  },
  {
    id: v4(),
    date: today.toString(),
    vaccineCode: '1',
    pathologyId: '397428000',
    doseNumber: 4,
    status: 'DUE',
    dateCriterion: {
      recommended: moment(new Date(staticBirthPT)).add(18, 'months').add(2, 'days').toString(),
      earliest: moment(new Date(staticBirthPT)).add(17, 'months').toString(),
      latest: moment(new Date(staticBirthPT)).add(19, 'months').toString()
    }
  },
  {
    id: v4(),
    date: today.toString(),
    vaccineCode: '1',
    pathologyId: '76902006',
    doseNumber: 4,
    status: 'DUE',
    dateCriterion: {
      recommended: moment(new Date(staticBirthPT)).add(18, 'months').add(2, 'days').toString(),
      earliest: moment(new Date(staticBirthPT)).add(17, 'months').toString(),
      latest: moment(new Date(staticBirthPT)).add(19, 'months').toString()
    }
  },
  {
    id: v4(),
    date: today.toString(),
    vaccineCode: '1',
    pathologyId: '27836007',
    doseNumber: 4,
    status: 'DUE',
    dateCriterion: {
      recommended: moment(new Date(staticBirthPT)).add(18, 'months').add(2, 'days').toString(),
      earliest: moment(new Date(staticBirthPT)).add(17, 'months').toString(),
      latest: moment(new Date(staticBirthPT)).add(19, 'months').toString()
    }
  },
  {
    id: v4(),
    date: today.toString(),
    vaccineCode: '1',
    pathologyId: '398102009',
    doseNumber: 4,
    status: 'DUE',
    dateCriterion: {
      recommended: moment(new Date(staticBirthPT)).add(18, 'months').add(2, 'days').toString(),
      earliest: moment(new Date(staticBirthPT)).add(17, 'months').toString(),
      latest: moment(new Date(staticBirthPT)).add(19, 'months').toString()
    }
  }
]

const brasilianRecommendations1Year = [
  {
    id: v4(),
    date: today.toString(),
    vaccineCode: '1',
    pathologyId: '9861002',
    doseNumber: 3,
    status: 'DUE',
    dateCriterion: {
      recommended: moment(new Date(staticBirthPT)).add(1, 'year').add(2, 'days').toString(),
      earliest: moment(new Date(staticBirthPT)).add(11, 'months').toString(),
      latest: moment(new Date(staticBirthPT)).add(1, 'year').add(1, 'months').toString()
    }
  },
  {
    id: v4(),
    date: today.toString(),
    vaccineCode: '1',
    pathologyId: '23511006',
    doseNumber: 3,
    status: 'DUE',
    dateCriterion: {
      recommended: moment(new Date(staticBirthPT)).add(1, 'year').add(2, 'days').toString(),
      earliest: moment(new Date(staticBirthPT)).add(11, 'months').toString(),
      latest: moment(new Date(staticBirthPT)).add(1, 'year').add(1, 'months').toString()
    }
  },
  {
    id: v4(),
    date: today.toString(),
    vaccineCode: '1',
    pathologyId: '14189004',
    doseNumber: 1,
    status: 'DUE',
    dateCriterion: {
      recommended: moment(new Date(staticBirthPT)).add(1, 'year').add(2, 'days').toString(),
      earliest: moment(new Date(staticBirthPT)).add(11, 'months').toString(),
      latest: moment(new Date(staticBirthPT)).add(1, 'year').add(1, 'months').toString()
    }
  },
  {
    id: v4(),
    date: today.toString(),
    vaccineCode: '1',
    pathologyId: '240526004',
    doseNumber: 1,
    status: 'DUE',
    dateCriterion: {
      recommended: moment(new Date(staticBirthPT)).add(1, 'year').add(2, 'days').toString(),
      earliest: moment(new Date(staticBirthPT)).add(11, 'months').toString(),
      latest: moment(new Date(staticBirthPT)).add(1, 'year').add(1, 'months').toString()
    }
  },
  {
    id: v4(),
    date: today.toString(),
    vaccineCode: '1',
    pathologyId: '36653000',
    doseNumber: 1,
    status: 'DUE',
    dateCriterion: {
      recommended: moment(new Date(staticBirthPT)).add(1, 'year').add(2, 'days').toString(),
      earliest: moment(new Date(staticBirthPT)).add(11, 'months').toString(),
      latest: moment(new Date(staticBirthPT)).add(1, 'year').add(1, 'months').toString()
    }
  },
  {
    id: v4(),
    date: today.toString(),
    vaccineCode: '1',
    pathologyId: '709410003',
    doseNumber: 4,
    status: 'DUE',
    dateCriterion: {
      recommended: moment(new Date(staticBirthPT)).add(18, 'months').add(2, 'days').toString(),
      earliest: moment(new Date(staticBirthPT)).add(17, 'months').toString(),
      latest: moment(new Date(staticBirthPT)).add(19, 'months').toString()
    }
  },
  {
    id: v4(),
    date: today.toString(),
    vaccineCode: '1',
    pathologyId: '397428000',
    doseNumber: 4,
    status: 'DUE',
    dateCriterion: {
      recommended: moment(new Date(staticBirthPT)).add(18, 'months').add(2, 'days').toString(),
      earliest: moment(new Date(staticBirthPT)).add(17, 'months').toString(),
      latest: moment(new Date(staticBirthPT)).add(19, 'months').toString()
    }
  },
  {
    id: v4(),
    date: today.toString(),
    vaccineCode: '1',
    pathologyId: '76902006',
    doseNumber: 4,
    status: 'DUE',
    dateCriterion: {
      recommended: moment(new Date(staticBirthPT)).add(18, 'months').add(2, 'days').toString(),
      earliest: moment(new Date(staticBirthPT)).add(17, 'months').toString(),
      latest: moment(new Date(staticBirthPT)).add(19, 'months').toString()
    }
  },
  {
    id: v4(),
    date: today.toString(),
    vaccineCode: '1',
    pathologyId: '27836007',
    doseNumber: 4,
    status: 'DUE',
    dateCriterion: {
      recommended: moment(new Date(staticBirthPT)).add(18, 'months').add(2, 'days').toString(),
      earliest: moment(new Date(staticBirthPT)).add(17, 'months').toString(),
      latest: moment(new Date(staticBirthPT)).add(19, 'months').toString()
    }
  },
  {
    id: v4(),
    date: today.toString(),
    vaccineCode: '1',
    pathologyId: '398102009',
    doseNumber: 4,
    status: 'DUE',
    dateCriterion: {
      recommended: moment(new Date(staticBirthPT)).add(18, 'months').add(2, 'days').toString(),
      earliest: moment(new Date(staticBirthPT)).add(17, 'months').toString(),
      latest: moment(new Date(staticBirthPT)).add(19, 'months').toString()
    }
  }
]

const germanRecommendations5Years = [
  {
    id: v4(),
    date: today.toString(),
    vaccineCode: '1',
    pathologyId: '76902006',
    doseNumber: 5,
    status: 'DUE',
    dateCriterion: {
      recommended: moment(new Date(staticBirthDE)).add(5, 'years').add(2, 'months').toString(),
      earliest: moment(new Date(staticBirthDE)).add(5, 'years').toString(),
      latest: moment(new Date(staticBirthDE)).add(6, 'year').add(11, 'months').toString()
    }
  },
  {
    id: v4(),
    date: today.toString(),
    vaccineCode: '1',
    pathologyId: '397428000',
    doseNumber: 5,
    status: 'DUE',
    dateCriterion: {
      recommended: moment(new Date(staticBirthDE)).add(5, 'years').add(2, 'months').toString(),
      earliest: moment(new Date(staticBirthDE)).add(5, 'years').toString(),
      latest: moment(new Date(staticBirthDE)).add(6, 'year').add(11, 'months').toString()
    }
  },
  {
    id: v4(),
    date: today.toString(),
    vaccineCode: '1',
    pathologyId: '27836007',
    doseNumber: 5,
    status: 'DUE',
    dateCriterion: {
      recommended: moment(new Date(staticBirthDE)).add(5, 'years').add(2, 'months').toString(),
      earliest: moment(new Date(staticBirthDE)).add(5, 'years').toString(),
      latest: moment(new Date(staticBirthDE)).add(6, 'year').add(11, 'months').toString()
    }
  }
]

const newRecom = [
  // {
  //   id: v4(),
  //   date: today.toString(),
  //   vaccineCode: '1',
  //   pathologyId: '40468003',
  //   doseNumber: 3,
  //   status: 'DUE',
  //   dateCriterion: {
  //     recommended: birthPT.add(1, 'year').add(10, 'day').toString(),
  //     earliest: birthPT.add(11, 'months').toString(),
  //     latest: birthPT.add(1, 'year').add(2, 'months').toString()
  //   }
  // }
]

export { portuguesRecommendations1Year, germanRecommendations5Years, brasilianRecommendations1Year }

export default newRecom
